<template>
  <div class="merchant">
    <div class="content">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label>商户名称:</label>
            <input
              v-model="search.name"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                @click="addrOrEdit()"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>

      <el-table
        border
        height="100%"
        :data="tableListData"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column
          show-overflow-tooltip
          label="商家名称"
          prop="name"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="商家地址"
          prop="address"
        ></el-table-column>

        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <button
              class="edit operate-button"
              type="button"
              @click="addrOrEdit(scope.row)"
            >
              修改
            </button>
            <button
              class="delete operate-button"
              @click="del(scope.row.id)"
              type="button"
            >
              删除
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <Page v-on:pagination="receivePaginationData"></Page>
    <merchant-update
      :merchantVisible="merchantVisible"
      :groupId="groupId"
      :merchant="merchant"
    ></merchant-update>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { updateShopUser, groupMerchant, resetPassword } from "@/api/url";

import Page from "../../../../../commons/parking/commons/page.vue";
import MerchantUpdate from "../MerchantUpdate/MerchantUpdate.vue";

export default {
  props: ["groupId"],
  data() {
    return {
      moduleName: "property",
      merchantVisible: false,

      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      dialogResetVisible: false,

      search: {
        pageNumber: 1,
        pageSize: 10,
        name: "",
        // carType:"",
        // plateType:"",
        // openMethod:"",
        // beginDate:'',
        // endDate:''
      },
      formData: {
        id: "",
        mchid: "",
        name: "",
        password: "0123456",
        address: "",
      },
      rechargeFormData: {
        name: "",
        id: "",
        currentMoney: "",
        rechargeMoney: "",
      },
      resetFormData: {
        name: "",
        id: "",
        // password:"",
        newPassword: "",
      },
      tableListData: [],

      formLabelWidth: "100px",

      rules: {
        name: [{ required: true, message: "请填写商家名称", trigger: "blur" }],
      },
      merchant:null
    };
  },
  components: {
    Page,

    MerchantUpdate,
  },
  watch: {
    groupId: function(newVal, oldVal) {
      this.tableList(1);
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },

  mounted: function() {},
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      this.$get(groupMerchant(), {
        parkingId: this.groupId,
        name: this.search.name,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
      });
    },
    searchList: function() {
      if (!this.groupId) {
        this.$message({
          type: "warning",
          message: "请选择集团",
        });
        return;
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    addrOrEdit(row) {
      this.merchant=row;
      this.merchantVisible = true;
    },

    del: function(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);

          _this
            .$deleteRequest(updateShopUser() + "/" + id )
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功！",
              });
              _this.tableList(_this.pageObj.curIndex);
              _this.$parent.merchantCallback();
            });
        }
      );
    },
    // 重置密码
    // resetPassword: function(password, id) {
    //   var _this = this;
    //   this.$putRequest(resetPassword(), {
    //     id: this.formData.mchid,
    //     password: this.formData.password,
    //   }).then((data) => {
    //     if (data.status != 200) return;
    //     this.$notify({
    //       title: "成功",
    //       message: "重置密码成功,默认密码是0123456",
    //       type: "success",
    //     });
    //   });
    // },

    // 修改密码
    //   resetPassword(id,name, password) {
    //   this.dialogResetVisible = true;
    //   this.resetFormData.id = id;
    //   this.resetFormData.name = name;
    //   // this.resetFormData.password = password
    //   this.resetFormData.newPassword = "";
    // },
    // resetTrue() {
    //   this.dialogResetVisible = false;
    //   this.$postRequest(resetPasswordV(), {
    //     id: this.resetFormData.id,
    //     password: this.resetFormData.newPassword
    //   }).then(data => {
    //     if (data.status != 200) return;
    //     this.$notify({
    //       type: "success",
    //       title: "成功",
    //       message: "修改成功！"
    //     });
    //     this.tableList(this.curIndex);
    //   });
    // },
    // 充值

    merchantUpdateCallback() {
      this.merchantVisible = false;
      this.tableList(this.pageObj.curIndex);
      this.$parent.merchantCallback();
    },
  },
};
</script>

<style scoped>
.sameLine .el-form-item__content .el-input {
  display: inline-block;
  width: 70%;
}

.tip {
  color: red;
}
</style>
<style lang="scss">
.merchant {
  width: 100%;
  height: 100%;
  .content {
    width: 100%;
    height: 100%;
  }
}
</style>
